import { marked } from 'marked';
import DOMPurify from 'dompurify';

// Basic markdown config
marked.setOptions({
  breaks: true,
  gfm: true,
});

// Harden links: open safely + block javascript: etc.
DOMPurify.addHook('afterSanitizeAttributes', (node) => {
  if (!(node instanceof HTMLElement)) return;

  if (node.tagName === 'A') {
    const href = node.getAttribute('href') || '';
    const lower = href.trim().toLowerCase();

    // Block dangerous protocols
    if (lower.startsWith('javascript:') || lower.startsWith('data:')) {
      node.removeAttribute('href');
    } else {
      node.setAttribute('target', '_blank');
      node.setAttribute('rel', 'noopener noreferrer nofollow');
    }
  }
});

export function renderMarkdown(md: string): string {
  const raw = marked.parse(md) as string;

  return DOMPurify.sanitize(raw, {
    USE_PROFILES: { html: true },
    FORBID_TAGS: ['style', 'script', 'iframe'],
    FORBID_ATTR: ['style', 'onerror', 'onclick', 'onload'],
  });
}
